/**
 * PaymentAccountFilters Component
 *
 * Wrapper around GenericFilters with payment account-specific configuration.
 * Reduced from 290 lines to 19 lines (93% reduction).
 */

import React from 'react';
import { GenericFilters } from '../ui/GenericFilters';
import { paymentAccountFilterConfig } from './paymentAccountFilterConfig';
import type { PaymentAccountFilters as PaymentAccountFilterType } from '../../types/payment-account';

interface PaymentAccountFiltersProps {
  filters: PaymentAccountFilterType;
  onFiltersChange: (filters: PaymentAccountFilterType) => void;
}

export function PaymentAccountFilters({ filters, onFiltersChange }: PaymentAccountFiltersProps) {
  return (
    <GenericFilters
      filters={filters}
      onFiltersChange={onFiltersChange}
      config={paymentAccountFilterConfig}
    />
  );
}
